import type { RouteLocationRaw, Router } from 'vue-router'

function isChangingPath(to: RouteLocationRaw, router: Router): boolean {
  try {
    const resolvedRoute = router.resolve(to)
    const { currentRoute } = router

    return resolvedRoute?.path !== currentRoute.value.path
  } catch {
    return true
  }
}

/**
 * Манкипатчим router.push, чтобы при изменении только query параметров, использовался replace
 */
export default defineNuxtPlugin({
  name: 'router-push-query',
  async setup() {
    const router = useRouter()

    const originalPush = router.push
    router.push = (...[to]: Parameters<typeof originalPush>) =>
      isChangingPath(to, router) ? originalPush(to) : router.replace(to)
  },
})
